import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../store/app.states';
import {DoctorService} from '../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {ExcelService} from '../../../services/excel.service';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';

@Component({
  selector: 'app-export-data',
  templateUrl: './export-data.component.html',
  styleUrls: ['./export-data.component.css']
})
export class ExportDataComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  title = 'Esporta dati'; // titolo generale
  patientSSN: string;
  //
  panelOpenStateUC = false;
  panelOpenStateCrohn = true;
  subscription1: Subscription;
  constructor(private router: Router,
              private store: Store<AppState>,
              public dialog: MatDialog) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
    });
  }
  ngOnDestroy() {
    this.subscription1.unsubscribe();
  }
}
